export const Notice = {
    "已读":"已讀",
    "已参与":"已參與",
    "未读":"未讀",
    "未参与":"未參與",
    "提醒未读成员查看":"提醒未讀成員查看",
    "系统提示":"系统提示",
    "是否要给未读的学员进行提醒本提醒仅通过微信推送只有微信绑定的用户才能收到此提醒":"是否要給未讀的學員進行提醒？本提醒僅通過微信推送，只有微信綁定的用戶才能收到此提醒!",
    "提醒已经发送到学生的微信":"提醒已經發送到學生的微信",
    "评论内容不允许为空":"評論內容不允許為空！",
    "还没有评论，发表第一个评论吧":"還沒有評論，發表第壹個評論吧",
    "点击评论":"點擊評論",
    "友善是交流的起点":"友善是交流的起點...",
    "删除评论成功":"刪除評論成功！",
    "评论成功":"評論成功",
    "全部评论":"全部評論",
    "发布你的评论":"發布妳的評論",
    "发布评论成功":"發布評論成功",
    "公告标题":"公告標題",
    "导入已有公告":"導入已有公告",
    "公告详情":"公告詳情",
    "选人":"選人",

}